// extracted by mini-css-extract-plugin
module.exports = {"application-list":"styles-module__application-list___3nuXC"};